'use client';

import { IconButton } from '@onyx/ui/components/colleague/icon-button';
import { getClassName } from '@onyx/ui/style-utils';

import styles from './top-app-bar.module.css';

export type TopAppBarProps = {
  hasBackButton?: boolean;
  title: string;
  backButtonClick?: () => void;
  trailingContent?: React.ReactNode;
  children?: React.ReactNode;
  menu?: React.ReactNode;
  className?: string;
};

export const TopAppBar = ({
  hasBackButton,
  title,
  backButtonClick,
  trailingContent,
  children,
  menu,
  className,
}: TopAppBarProps) => {
  return (
    <header className={getClassName([styles.topAppBar, className])}>
      <div className={styles.content}>
        <div className={styles.icon}>
          {hasBackButton && (
            <IconButton
              aria-label="Go back"
              onClick={backButtonClick}
              isInverse
              icon="ArrowBack"
            />
          )}
        </div>

        <div className={styles.headerContent}>
          <div className={styles.titleWrapper}>
            <h1 className={styles.title}>{title}</h1>
            {!!trailingContent && trailingContent}
          </div>
          {children}
        </div>

        <div className={styles.icon}>{menu}</div>
      </div>
    </header>
  );
};
